var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M73.37,62.76A39,39,0,1,0,62.76,73.37L85.2,95.8A7.5,7.5,0,0,0,95.8,85.2ZM41,65A24,24,0,1,1,65,41,24,24,0,0,1,41,65Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }